import { useContext, useEffect, useState } from "react";
import { StateContext } from "../../Middleware/context/StateProvider";
import { useAuth } from "../../Middleware/context/AuthContext";
import { db } from "../../Middleware/Firebase/firebase";
import { addDoc, collection } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { FGetBankTouaki } from "../../Middleware/Firebase/FGetBankTouaki"; // <- importe nomeado se arquivo exporta nomeado

function ReferenceCode({custoTotal}) {
  const navigate = useNavigate();

  const { user, userProfile } = useAuth();
  const basketCtx = useContext(StateContext);

  // Se o seu StateProvider expõe { state, dispatch }, pegue o basket daqui:
  const itemsInBasket = basketCtx?.state?.basket ?? []; // array de itens
  const [code, setCode] = useState("");

  // Banco
  const [bank, setBank] = useState([]);     // <- começa como array
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
//------------------------------------------------------------------
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        const data = await FGetBankTouaki(); // deve retornar array
        if (alive) setBank(Array.isArray(data) ? data : [data]); // normaliza para array
      } catch (e) {
        if (alive) setErr(e.message || "Falha ao buscar dados bancários.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  //---------------------------------------------------------

  const askOrder = async () => {
    try {
      // 1) Pré-validações
      if (!user?.uid) {
        alert("Precisas iniciar sessão para enviar o pedido.");
        return;
      }

      if (!Array.isArray(itemsInBasket) || itemsInBasket.length === 0) {
        alert("O carrinho está vazio.");
        return;
      }

      if (!code.trim()) {
        alert("Insere o código de referência do pagamento.");
        return;
      }

      // 2) Monta o payload
      const orderData = {
        requester: userProfile?.nome ?? user?.email ?? "Anónimo",
        requesterId: user.uid,
        whatsapp: userProfile?.telefone ?? "",
        items: { basket: itemsInBasket }, // <- garante shape com basket
        payCode: code.trim(),
        createdAt: new Date(), // ou serverTimestamp() se quiser
        total:custoTotal 
      };

      // 3) Envia para o Firestore
      await addDoc(collection(db, "orders"), orderData);

      // 4) Feedback e navegação
      alert("O seu pedido foi enviado com sucesso!");
      setCode("");
      navigate("/");
    } catch (err) {
      console.error("Erro ao enviar pedido:", err);
      alert("Ocorreu um erro ao enviar o pedido. Tente novamente.");
    }
  };

  const referencia = bank?.[0]?.pagamentoReferencia ?? "—";

  return (
    <div className="payment-form fade">
      <h3>
        Pagamento por Express {loading ? "(a carregar…)" : `(${referencia})`}
      </h3>

      {err && (
        <div className="text-red-600 text-sm mb-2">
          {err}
        </div>
      )}

      <input
        name="numero"
        value={code}
        placeholder="Código de Referência do Pagamento"
        onChange={(e) => setCode(e.target.value)}
      />

      <button
        onClick={askOrder}
        className="pay-btn"
        disabled={loading || !itemsInBasket.length}
        title={loading ? "A carregar dados bancários..." : undefined}
      >
        Confirmar Código
      </button>
    </div>
  );
}

export default ReferenceCode;